export default __webpack_public_path__ + "static/media/70ba4f931c84d6e6b4b4b78418a11cca.svg";